import { useAtom } from 'jotai';

import { EVENT_ID } from '@constants/atoms';
import { useGetEventAppearance } from '@api/hooks';

import useLOCevent from './useLOCevent';

// cannot add this hook to ./index because of @api/hooks dependency cycle
const useEventColors = () => {
  const locEvent = useLOCevent();
  const [_eventId] = useAtom(EVENT_ID);
  const eventId = locEvent?.id ?? _eventId;

  const getAppearanceQuery = useGetEventAppearance({ id: eventId }, { enabled: eventId });
  const additionalColours = getAppearanceQuery.data?.additionalColours;

  return additionalColours;
};

export default useEventColors;
